import React, { useState } from "react";
import { Avatar } from "antd";
import { fullName } from "../Helper";

const ProfileAvatar = ({ size, name, shape = null }) => {
  // const [avatarStyle, setAvatarStyle] = useState({
  //   backgroundColor: "#f56a00"
  // });

  return (
    <Avatar size={size} shape={shape ? shape : "round"}>
      {fullName(name)}
    </Avatar>
  );
};
export { ProfileAvatar };
